import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { all, put, select, takeEvery, call, takeLatest } from 'redux-saga/effects';
import i18next from 'i18next';
import ddt from '@wix/da-ddt';
import { withCursor, selectors } from '../../Stream';
import { createCallbackActionCreator } from '../../Stream/helpers';
import { request } from '../../xhr';
import { putErrorNotification } from '../../utils/saga';
import { initializeStreamAndFetchFirst, fetchNext, getStreamId, removeDeviationFromGroup, removeDeviationFromGroupSuccess } from './actionCreators';
const logger = ddt.createLogger('deviationsaga');
function* handleInitializeStreamAndFetchFirst(action) {
    const { deviationId } = action.payload;
    const fetchNextCallback = createCallbackActionCreator(fetchNext.toString());
    yield put(withCursor.actions.initialize({
        streamId: getStreamId(deviationId),
        itemsPerFetch: 25,
        items: [],
        hasMore: true,
        cursor: undefined,
        streamParams: {
            deviationId: deviationId
        },
        fetchNextCallback
    }));
}
function fakeGroupStream(initialCursor = 0, hasMore = true) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        const groups = require('@wix/da-sample-data').moreGroups;
        return (options)=>{
            logger.log('fakeGroupStream', options);
            const { cursor = 0 } = options.params;
            return {
                cursor: cursor <= 2 ? cursor + 1 : undefined,
                results: [
                    ...groups,
                    ...groups,
                    ...groups,
                    groups[0]
                ].map((group)=>_object_spread_props(_object_spread({}, group), {
                        userId: cursor * 100000 + group.userId
                    }))
            };
        };
    }
    return ()=>{};
}
function* handleFetchNext(action) {
    const { streamId } = action.payload;
    const { cursor, limit, streamParams } = yield select((state)=>({
            streamParams: selectors.getStreamParams(state, streamId),
            cursor: withCursor.selectors.getCursor(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId)
        }));
    const params = {
        deviationid: streamParams.deviationId,
        cursor,
        limit
    };
    const result = yield call(request, {
        method: 'get',
        url: 'deviation/featured_in_groups',
        params
    }, fakeGroupStream());
    if (result && !result.error) {
        const { results, cursor: nextCursor } = result;
        yield put(withCursor.actions.fetchSuccessDeduped({
            streamId,
            hasMore: nextCursor !== undefined,
            cursor: nextCursor,
            items: results
        }));
    } else {
        var _result;
        yield put(withCursor.actions.fetchFailure({
            streamId,
            errorMsg: `Failed to fetch: ${(_result = result) === null || _result === void 0 ? void 0 : _result.error}`
        }));
    }
}
function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (typeof window !== 'undefined' && window.doError) {
            return {
                error: 'invalid_request',
                errorDescription: 'Request field validation failed.',
                errorDetails: {
                    groupId: 'groupid is required'
                },
                status: 'error'
            };
        }
        return {
            success: true
        };
    }
}
function* removeDeviationFromGroupSaga({ payload }) {
    const { deviationId, groupId } = payload;
    if (!deviationId || !groupId) {
        logger.error('Tried to remove an invalid deviation', payload);
        return;
    }
    const data = {
        deviationid: deviationId,
        groupid: groupId
    };
    const options = {
        method: 'post',
        url: 'deviation/remove_from_group',
        data
    };
    const result = yield call(request, options, fakeResponse);
    if (!result || result.error) {
        var _result;
        const error = (_result = result) === null || _result === void 0 ? void 0 : _result.error;
        logger.error('Error removing deviation from group:', data, error);
        yield putErrorNotification(i18next.t('deviationGroupListPopup.errorNotification'));
        return;
    }
    if (result.success) {
        yield put(removeDeviationFromGroupSuccess({
            deviationId,
            groupId
        }));
    }
}
export default function* rootSaga() {
    yield all([
        takeEvery(initializeStreamAndFetchFirst, handleInitializeStreamAndFetchFirst),
        takeEvery(fetchNext, handleFetchNext),
        takeLatest(removeDeviationFromGroup, removeDeviationFromGroupSaga)
    ]);
}
